export default __webpack_public_path__ + "static/media/defendant2.70c65dd6.png";